import { Button, Col, Form, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../../../inboxItemPages/components/commentBox";
import TaskCheckedList from "../../../../../inboxItemPages/components/taskCheckedList";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../../firebase";

function OwnerDoingMakeReady({ itemId, listId, checkedItems }) {
  const isItemChecked = checkedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.
  const [isDisabled, setIsDisabled] = useState(isItemChecked);

  const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  const handleComplete = async () => {
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
    setIsDisabled(true);

        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical">
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <Row gutter={[0, 16]}>
              <Col span={24}>
                <p className="yellow-info-text">
                  <strong>
                    Send this email to the property owner in appfolio
                  </strong>{" "}
                  -{" "}
                  <strong className="red-info-heading">
                    put the property address in the subject line
                  </strong>
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  We have finished inspecting the property at the above address
                  and it is ready for your make ready work.
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  Please keep us posted on the progress and let me know when
                  complete so I can get the home listed asap. Remember there
                  will be a mandatory inspection prior to beginning showings and
                  there is a charge of $75 for this when you or your own vendor
                  are doing the work.
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  I will also need an itemized list from you with charges for
                  each item in the next 15 days so that I can finish the
                  Security Deposit refund process in a timely manner.
                </p>
              </Col>
              <Col span={24}>
                <p className="yellow-info-text">
                  If I do not get this info from you I will need to refund the
                  full security deposit to the former tenant so please get that
                  to me right away.
                </p>
              </Col>
            </Row>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button
                  type="primary"
                  onClick={handleComplete}
                  disabled={isDisabled}
                >
                  Complete
                </Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default OwnerDoingMakeReady;
